import { render, staticRenderFns } from "./UnpaidOrder.vue?vue&type=template&id=45682424&scoped=true"
import script from "./UnpaidOrder.vue?vue&type=script&lang=js"
export * from "./UnpaidOrder.vue?vue&type=script&lang=js"
import style0 from "./UnpaidOrder.vue?vue&type=style&index=0&id=45682424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45682424",
  null
  
)

export default component.exports